// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { Regex } from '../../_common/api/regex';
import Button from '../../_common/form/Button';
import Form from '../../_common/form/Form';
import HamLink from '../../_common/form/HamLink';
import Input from '../../_common/form/Input';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Modal from '../../_common/Modal';
import Card from '../Card';
import { HamQuest } from '../../../App';

const FormWrapper = styled(Form)`
    display: flex;
    flex-direction: column;
`
const Row = styled.div`
    display: flex;
    justify-content: flex-end;
`
const ForgotPW = styled(HamLink)`
    font-size: 0.6em;
`

const LogIn = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
        logIn,
        guestLogIn,
        logOut
    } = useGlobalState();

    useEffect(() => {
        if (active_user.isGuestUser) logOut()
    }, [])

    if (active_user.isGuestUser) {
        return <Navigate to='/' replace />;
    }

    const promptGuest = () => {
        Modal.Confirmation({
            title: 'Guest Log In',
            body: 'Logging in as a guest only allows access to viewing washes / clubs. Are you sure you wish to continue?',
            closeAfter: true,
        })
            .then(res => { if (res) guestLogIn() })
    }

    const handlePWReset = () => {
        Modal.Show({
            title: 'Enter your Email',
            body: (
                <Form
                    inputs={{
                        email: '',
                    }}
                    onSubmit={(e) => HamQuest
                        .getQuery(QuestRoute.user.forgotPassword, {
                            email: e.email
                        })
                        .then(() => {
                            Modal.Show({
                                title: 'Email Sent',
                                body: 'Password recovery email sent!',
                                type: 'success',
                            })
                        })
                        .catch(ex => {
                            Modal.Show({
                                type: 'error',
                                title: 'Failed to Email',
                                body: ex.blob || 'Something went wrong. Please try again.'
                            })
                        })
                    }
                    submitButton={`Send Password Reset`}
                    style={{ width: '80vw' }}
                >
                    <Input
                        label='Email'
                        name='email'
                        type='email'
                        validate={Regex.match.email}
                        required
                    />
                </Form>
            )
        })
    }

    return (
        <>
            <Card>
                <FormWrapper
                    inputs={{
                        email: process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_ADMIN : '',
                        password: process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_PW : '',
                        // email: '',
                        // password: '',
                        rememberMe: false,
                    }}
                    onSubmit={logIn}
                    submitButton='Sign In'
                    submittingButton='Signing In'
                >
                    <Row>
                        <ForgotPW onClick={handlePWReset}>Forgot Password?</ForgotPW>
                    </Row>
                    <Input
                        label='Email'
                        name='email'
                        type='email'
                        required
                    />
                    <Input
                        label='Password'
                        name='password'
                        type='password'
                        required
                    />
                    <Input type='submit'>Sign In</Input>
                    <Button to='/signUp'>Sign Up</Button>
                    <Button onClick={promptGuest} type='button'>Continue as Guest</Button>
                </FormWrapper>
            </Card>
        </>
    );
}

export default LogIn;


export const handlePWReset = () => {
    Modal.Show({
        title: 'Enter your Email',
        body: (
            <Form
                inputs={{
                    email: '',
                }}
                onSubmit={(e) => HamQuest
                    .getQuery(QuestRoute.user.forgotPassword, {
                        email: e.email
                    })
                    .then(() => {
                        Modal.Show({
                            title: 'Email Sent',
                            body: 'Password recovery email sent!',
                            type: 'success',
                        })
                    })
                    .catch(ex => {
                        Modal.Show({
                            type: 'error',
                            title: 'Failed to Email',
                            body: ex.blob || 'Something went wrong. Please try again.'
                        })
                    })
                }
                submitButton={`Send Password Reset`}
            >
                <Input
                    label='Email'
                    name='email'
                    type='email'
                    validate={Regex.match.email}
                    required
                />
            </Form>
        )
    })
} 
